import SignUpEmailSent from "../../components/auth/signup-email-sent";
import Header from "../../components/header";

const SignUpEmailSentPage = () => {
  return (
    <>
      <Header />
      <SignUpEmailSent />
    </>
  );
};

export default SignUpEmailSentPage;
